let env = process.env.REACT_APP_ENV ? process.env.REACT_APP_ENV : process.env.NODE_ENV;
if (!env) {
	console.error('ENV: ', env);
	env = 'development';
}

let gamesDbName = 'games-test';
let gameUrl = 'localhost:3000';
let apiURL = 'http://localhost:8080/api/';
if (env === 'test') {
	gameUrl = 'cgl-elevspilkort-test.web.app';
	apiURL = 'https://cgl-elevspilkort-test.web.app/api/';
}
if (env === 'production') {
	gameUrl = 'elevspil.dk';
	apiURL = 'https://cgl-elevspilkort-production.web.app/api/';
	gamesDbName = 'games';

}

const appConfig = {
	env: env,
	apiURL: apiURL,
	gameUrl: gameUrl,
	gamesDbName: gamesDbName
};

export default appConfig;